import { useQuery } from "@tanstack/react-query";
import useWorkspace from "./useWorkspace";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";
import PageAPI from "../../api/PageAPI";
import { Page } from "../../../types/GlobalInterfaces";

const emptyPages: [] = [];

const useWorkspacePages = () => {
  const { workspace } = useWorkspace();
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const hasPages = Array.isArray(workspace?.Pages) && !!workspace.Pages.length;

  const pages = useQuery({
    queryKey: ["pages", workspace?.id],
    queryFn: () =>
      PageAPI.getPagesByIds(workspace.id, workspace.Pages).then(
        (data) => data.data.data.pages
      ),
    enabled: !!workspace && hasPages && queriesEnabled,
  });

  return {
    pages: (pages.data || emptyPages) as Page[],
    pagesLoading: (pages.isLoading || queriesEnabled === false) && hasPages,
  };
};

export default useWorkspacePages;
